module.exports = __webpack_public_path__ + "static/heart-2-1-ec8a166bde6284abdeb2f9ad1195c894.png";